import apiClient from './apiClient.js';
import {
  ITEM_CLOTH_BY_STORE_URL,
  UPDATE_CLOTH_ITEM_URL,
  FIND_CLOTH_BY_ID_URL,
} from '../constant/apiConstants.js';

/**
 * GET /cloth/getByStoreId?storeId=...
 *
 * Returns ApiResponseModel
 */
export const fetchClothListByStore = async (storeId) => {
  try {
    const response = await apiClient.get(ITEM_CLOTH_BY_STORE_URL, {
      params: { storeId },
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Fetch cloth list error:", error.response.data);
      return error.response.data;
    }

    console.error("Network error:", error);

    return {
      status: "failed",
      payload: null,
      message: "Something went wrong. Please try again later.",
    };
  }
};

/**
 * GET /cloth/find?barcodeId=...&storeId=...
 *
 * Returns ApiResponseModel<ItemCloth>
 */
export const findClothById = async (barcodeId, storeId) => {
  try {
    const response = await apiClient.get(FIND_CLOTH_BY_ID_URL, {
      params: {
        barcodeId,
        storeId,
      },
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Find cloth error:", error.response.data);
      return error.response.data;
    }

    console.error("Network error:", error);

    return {
      status: "failed",
      payload: null,
      message: "Something went wrong. Please try again later.",
    };
  }
};

/**
 * PUT /cloth/update?clothId=...
 *
 * Request Body:
 * [
 *   {
 *     "key": "price",
 *     "value": "650"
 *   }
 * ]
 *
 * Returns ApiResponseModel<ItemCloth>
 */
export const updateClothItem = async (clothId, updateRequests) => {
  try {
    const response = await apiClient.put(
      UPDATE_CLOTH_ITEM_URL,
      updateRequests,
      {
        params: {
          clothId,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Update cloth item error:", error.response.data);
      return error.response.data;
    }

    console.error("Network error:", error);

    return {
      status: "failed",
      payload: null,
      message: "Something went wrong. Please try again later.",
    };
  }
};